// === Zod schemas: task_type ===
// Ported from PHP Click2Gro: TaskTypeModel / TaskType entity (admin/global table)
// Table: task_type

import { z } from 'zod';

const flagField = z.number().int().min(0).max(1).nullable();

export const TaskTypeSchema = z.object({
  id:               z.number().int().positive(),
  task_name:        z.string().max(31).nullable(),
  task_cost:        z.number().nullable(),
  select_spray:     flagField,
  start_time:       flagField,
  finish_time:      flagField,
  operators_name:   flagField,
  wind_speed:       flagField,
  ppe_name:         flagField,
  batch_number:     flagField,
  chemical_rate:    flagField,
  assign_operator:  flagField,
  assign_block:     flagField,
  select_block:     flagField,
  select_crop:      flagField,
  select_week:      flagField,
  created_by:       z.string().max(300).nullable(),
  updated_by:       z.string().max(300).nullable(),
  created_at:       z.string().datetime({ offset: true }).nullable(),
  updated_at:       z.string().datetime({ offset: true }).nullable(),
  deleted_at:       z.string().datetime({ offset: true }).nullable(),
});

export const TaskTypeInsertSchema = TaskTypeSchema.omit({
  id: true,
  created_at: true,
  updated_at: true,
  deleted_at: true,
}).partial({
  task_cost:       true,
  select_spray:    true,
  start_time:      true,
  finish_time:     true,
  operators_name:  true,
  wind_speed:      true,
  ppe_name:        true,
  batch_number:    true,
  chemical_rate:   true,
  assign_operator: true,
  assign_block:    true,
  select_block:    true,
  select_crop:     true,
  select_week:     true,
  created_by:      true,
  updated_by:      true,
});

export const TaskTypeUpdateSchema = TaskTypeInsertSchema.partial();

export type TaskType       = z.infer<typeof TaskTypeSchema>;
export type TaskTypeInsert = z.infer<typeof TaskTypeInsertSchema>;
export type TaskTypeUpdate = z.infer<typeof TaskTypeUpdateSchema>;
